import DOMPurify from 'dompurify';

export const sanitize = (rawHtml: string): string => {
  // Allow required editor formatting while removing executable content.
  return DOMPurify.sanitize(rawHtml || '', {
    ALLOWED_TAGS: [
      'p',
      'br',
      'strong',
      'b',
      'em',
      'i',
      'u',
      's',
      'strike',
      'blockquote',
      'pre',
      'code',
      'ol',
      'ul',
      'li',
      'span',
      'div',
      'h1',
      'h2',
      'h3',
      'h4',
      'h5',
      'h6',
      'sub',
      'sup',
      'a'
    ],
    ALLOWED_ATTR: [
      'class',
      'style',
      'href',
      'target',
      'rel',
      'title'
    ],
    FORBID_TAGS: [
      'script',
      'iframe',
      'object',
      'embed',
      'form',
      'input',
      'button',
      'textarea',
      'select',
      'option',
      'svg',
      'math',
      'img',
      'video',
      'audio',
      'source',
      'canvas',
      'meta',
      'link',
      'base'
    ],
    FORBID_ATTR: [
      'src',
      'srcset',
      'srcdoc',
      'action',
      'formaction',
      'background',
      'poster'
    ],
    ALLOW_DATA_ATTR: false,
    KEEP_CONTENT: true
  });
};